<template>
	<div class="contents-wrap">
		<div class="result">
			<transition name="slide-fade">
				<div class="answer-wrap">
					<div class="answer-title">
						★熟睡度10％
						<div class="text">要注意！睡眠不足が溜まっています</div>
					</div>
					<div class="answer-body">
						<p>慢性的な疲労感や集中力の低下など、心身にもつらい影響が現れているのではないでしょうか。このままでは重大なミスや事故、病気を招く危険性があります。まずは、睡眠不足解消のために、現在のご自身の睡眠を振り返ってみましょう。</p>
						<div class="sub-cts"><h2>★さらにぐっすり眠るためには？</h2>
							<p>夜ふかしが習慣になってしまっている人は、とりあえず「先週より30分早寝する」を意識してみてください。「昨日より15分」でもOKです。小さな変化を積み重ねて、睡眠時間を確保するようにしましょう。また、昼寝のとり過ぎ、運動不足、夜に明るい照明の下で過ごす、シャワーだけで済ませている、スマホをベッドに持ち込むなど、睡眠に悪いことを避けましょう。</p>
						</div>
						<div class="sub-cts">
							<h2>▼こちらもCHECK</h2>
							<ul>
								<li><a href="https://xn--z8js3azm.com/beauty/16">夜ふかし続き、徹夜明け…眠気を覚まして仕事を乗り切る6つのコツ</a></li>
								<li><a href="https://xn--z8js3azm.com/beauty/26">テレワークは睡眠不足になりやすい？リズムを崩さない4つのコツ</a></li>
							</ul>
						</div>
					</div>
					<div class="btn-area">
						<button @click="next(0)" class="btnReset">スタートに戻る</button>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ResultCts04',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>